export default __webpack_public_path__ + "static/index-title-feature-ko-a20a92d72a009218ed829513ab1abc2c.png";